
import { FIREARM_METADATA } from './firearm.metadata';
import { FirearmBase } from './firearm.model.base';
import { AuditQueryResult, CrudEntity, CrudEntityConstructionOptions, CrudRevisionEntity, fieldModified, RevisionType, UsernameRevisionInfo } from '@scisys-uim/uim-common';


export interface Firearm extends FirearmBase {
}

export interface FirearmTransient { }

export class Firearm extends CrudEntity<Firearm, number, FirearmTransient> implements FirearmTransient {
  constructor(source?: Partial<Firearm>, options?: CrudEntityConstructionOptions<Firearm, number, FirearmTransient>) {
    super(FIREARM_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
    this.suspended = this.suspended || false;
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}

export class FirearmRevision extends Firearm implements CrudRevisionEntity {

  _revisionInfo: UsernameRevisionInfo = null;
  _revisionChangedFields: string[] = [];
  _revisionType: RevisionType = null;

  constructor(auditQueryResult: AuditQueryResult<Firearm>) {
    super(auditQueryResult.entity, { readOnly: true });
    this._revisionInfo = auditQueryResult.revision;
    this._revisionChangedFields = auditQueryResult.changes;
    this._revisionType = auditQueryResult.type;
  }

  fieldModified(field: string): boolean {
    return fieldModified(this, field);
  }

}